module.exports = __webpack_public_path__ + "dj.svg?ee0f02680d45a7e6819f244cac55c8b2";